import { Box, Card, Container, Stack, Typography, useTheme } from '@mui/material';
import Carousel, { CarouselArrows, useCarousel } from 'src/components/carousel';
import { useLocales } from 'src/locales';

const CONFIG1 = [
  { label: 'MERCHANT_001', imgUrl: './assets/images/home/merchants/MERCHANT_001.png' },
  { label: 'MERCHANT_002', imgUrl: './assets/images/home/merchants/MERCHANT_002.png' },
  { label: 'MERCHANT_003', imgUrl: './assets/images/home/merchants/MERCHANT_003.png' },
  { label: 'MERCHANT_004', imgUrl: './assets/images/home/merchants/MERCHANT_004.png' },
  { label: 'MERCHANT_005', imgUrl: './assets/images/home/merchants/MERCHANT_005.png' },

  { label: 'MERCHANT_006', imgUrl: './assets/images/home/merchants/MERCHANT_006.png' },
  { label: 'MERCHANT_007', imgUrl: './assets/images/home/merchants/MERCHANT_007.png' },
  { label: 'MERCHANT_008', imgUrl: './assets/images/home/merchants/MERCHANT_008.png' },
  { label: 'MERCHANT_009', imgUrl: './assets/images/home/merchants/MERCHANT_009.png' },
  { label: 'MERCHANT_010', imgUrl: './assets/images/home/merchants/MERCHANT_010.png' },

  { label: 'MERCHANT_011', imgUrl: './assets/images/home/merchants/MERCHANT_011.png' },
  { label: 'MERCHANT_012', imgUrl: './assets/images/home/merchants/MERCHANT_012.png' },
  { label: 'MERCHANT_013', imgUrl: './assets/images/home/merchants/MERCHANT_013.png' },
  { label: 'MERCHANT_014', imgUrl: './assets/images/home/merchants/MERCHANT_014.png' },
  { label: 'MERCHANT_015', imgUrl: './assets/images/home/merchants/MERCHANT_015.png' },

  { label: 'MERCHANT_016', imgUrl: './assets/images/home/merchants/MERCHANT_016.png' },
];

const CONFIG2 = [
  { label: 'MERCHANT_017', imgUrl: './assets/images/home/merchants/MERCHANT_017.png' },
  { label: 'MERCHANT_041', imgUrl: './assets/images/home/merchants/MERCHANT_041.png' },
  { label: 'MERCHANT_018', imgUrl: './assets/images/home/merchants/MERCHANT_018.png' },
  { label: 'MERCHANT_019', imgUrl: './assets/images/home/merchants/MERCHANT_019.png' },
  { label: 'MERCHANT_021', imgUrl: './assets/images/home/merchants/MERCHANT_021.png' },

  { label: 'MERCHANT_022', imgUrl: './assets/images/home/merchants/MERCHANT_022.png' },

  { label: 'MERCHANT_023', imgUrl: './assets/images/home/merchants/MERCHANT_023.png' },
  { label: 'MERCHANT_023', imgUrl: './assets/images/home/merchants/MERCHANT_024.png' },

  { label: 'MERCHANT_025', imgUrl: './assets/images/home/merchants/MERCHANT_025.png' },
  { label: 'MERCHANT_026', imgUrl: './assets/images/home/merchants/MERCHANT_026.png' },

  { label: 'MERCHANT_027', imgUrl: './assets/images/home/merchants/MERCHANT_027.png' },
  { label: 'MERCHANT_028', imgUrl: './assets/images/home/merchants/MERCHANT_028.png' },
  { label: 'MERCHANT_029', imgUrl: './assets/images/home/merchants/MERCHANT_029.png' },
  { label: 'MERCHANT_030', imgUrl: './assets/images/home/merchants/MERCHANT_030.png' },
  { label: 'MERCHANT_031', imgUrl: './assets/images/home/merchants/MERCHANT_031.png' },

  { label: 'MERCHANT_032', imgUrl: './assets/images/home/merchants/MERCHANT_032.png' },
];

const CONFIG3 = [
  { label: 'MERCHANT_033', imgUrl: './assets/images/home/merchants/MERCHANT_033.png' },
  { label: 'MERCHANT_034', imgUrl: './assets/images/home/merchants/MERCHANT_034.png' },
  { label: 'MERCHANT_035', imgUrl: './assets/images/home/merchants/MERCHANT_035.png' },
  { label: 'MERCHANT_036', imgUrl: './assets/images/home/merchants/MERCHANT_036.png' },
  { label: 'MERCHANT_037', imgUrl: './assets/images/home/merchants/MERCHANT_037.png' },

  { label: 'MERCHANT_038', imgUrl: './assets/images/home/merchants/MERCHANT_038.png' },
  { label: 'MERCHANT_039', imgUrl: './assets/images/home/merchants/MERCHANT_039.png' },
  { label: 'MERCHANT_040', imgUrl: './assets/images/home/merchants/MERCHANT_040.png' },
  { label: 'MERCHANT_020', imgUrl: './assets/images/home/merchants/MERCHANT_020.png' },
  { label: 'MERCHANT_042', imgUrl: './assets/images/home/merchants/MERCHANT_042.png' },

  { label: 'MERCHANT_043', imgUrl: './assets/images/home/merchants/MERCHANT_043.png' },
  { label: 'MERCHANT_044', imgUrl: './assets/images/home/merchants/MERCHANT_044.png' },
  { label: 'MERCHANT_045', imgUrl: './assets/images/home/merchants/MERCHANT_045.png' },
  { label: 'MERCHANT_046', imgUrl: './assets/images/home/merchants/MERCHANT_046.png' },
  { label: 'MERCHANT_047', imgUrl: './assets/images/home/merchants/MERCHANT_047.png' },

  { label: 'MERCHANT_048', imgUrl: './assets/images/home/merchants/MERCHANT_048.png' },
];

function HomeOurMerchants() {
  const theme = useTheme();
  const { t } = useLocales();

  const carousel1 = useCarousel({
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '0px',
    slidesToShow: 5,
    // auto play
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 2000,
    // responsive
    responsive: [
      {
        // Down 900
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        // Down 650
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        // Down 400
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  const renderCarousel1 = (
    <Box sx={{ position: 'relative' }}>
      <CarouselArrows filled>
        <Box
          component={Carousel}
          ref={carousel1.carouselRef}
          {...carousel1.carouselSettings}
          sx={{
            width: '120%',
            marginLeft: '-10%',
          }}
        >
          {CONFIG1.map((item, index) => (
            <Box key={index}>
              <Stack
                component={Card}
                sx={{
                  background: '#fff',
                  border: `2px solid ${theme.palette.primary.main}`,
                  p: 2,
                  width: '95%',
                  height: { xs: '180px', md: '140px' },
                  margin: '0 auto',
                }}
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  component="img"
                  src={item.imgUrl}
                  alt={item.label}
                  sx={{ objectFit: 'contain', height: '80%' }}
                />
              </Stack>
            </Box>
          ))}
        </Box>
      </CarouselArrows>
    </Box>
  );

  const carousel2 = useCarousel({
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '0px',
    slidesToShow: 5,
    // auto play
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 2000,
    // responsive
    responsive: [
      {
        // Down 900
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        // Down 650
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        // Down 400
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  const renderCarousel2 = (
    <Box sx={{ position: 'relative' }}>
      <CarouselArrows filled>
        <Box
          component={Carousel}
          ref={carousel2.carouselRef}
          {...carousel2.carouselSettings}
          sx={{
            width: '140%',
            marginLeft: '-20%',
          }}
        >
          {CONFIG2.map((item, index) => (
            <Box key={index}>
              <Stack
                component={Card}
                sx={{
                  background: '#fff',
                  border: `2px solid ${theme.palette.primary.main}`,
                  width: '95%',
                  height: { xs: '180px', md: '140px' },
                  margin: '0 auto',
                }}
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  component="img"
                  src={item.imgUrl}
                  alt={item.label}
                  sx={{ objectFit: 'contain', height: '80%' }}
                />
              </Stack>
            </Box>
          ))}
        </Box>
      </CarouselArrows>
    </Box>
  );

  const carousel3 = useCarousel({
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '0px',
    slidesToShow: 5,
    // auto play
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 2000,
    // responsive
    responsive: [
      {
        // Down 900
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        // Down 650
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        // Down 400
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  const renderCarousel3 = (
    <Box sx={{ position: 'relative' }}>
      <CarouselArrows filled>
        <Box
          component={Carousel}
          ref={carousel3.carouselRef}
          {...carousel3.carouselSettings}
          sx={{
            width: '120%',
            marginLeft: '-10%',
          }}
        >
          {CONFIG3.map((item, index) => (
            <Box key={index}>
              <Stack
                component={Card}
                sx={{
                  background: '#fff',
                  border: `2px solid ${theme.palette.primary.main}`,
                  width: '95%',
                  height: { xs: '180px', md: '140px' },
                  margin: '0 auto',
                }}
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  component="img"
                  src={item.imgUrl}
                  alt={item.label}
                  sx={{ objectFit: 'contain', height: '80%' }}
                />
              </Stack>
            </Box>
          ))}
        </Box>
      </CarouselArrows>
    </Box>
  );

  return (
    <Stack
      spacing={3}
      sx={{
        mb: { xs: 5, md: 10 },
      }}
    >
      <Container>
        <Typography
          variant="h2"
          sx={{ color: theme.palette.primary.main }}
          textTransform="uppercase"
        >
          {t('walkup_lang_208')}
        </Typography>
      </Container>

      <Stack spacing={2}>
        {renderCarousel1}
        {renderCarousel2}
        {renderCarousel3}
      </Stack>
    </Stack>
  );
}

export default HomeOurMerchants;
